/**
 * Adapter K1 of INVENTORY (F3): items → flat exportable dataset.
 */

import {
  buildDataset,
  type ExportColumn,
  type ExportDataset,
  type ExportMetadata,
} from "../export";
import { type InventoryItemLike, isLowStock } from "./stock";

export interface InventoryExportRow extends InventoryItemLike {
  name: string | null;
  condition?: string | null;
  responsible_name?: string | null;
  venueName?: string | null;
  notes?: string | null;
}

export function inventoryExportColumns(): ExportColumn<InventoryExportRow>[] {
  return [
    { key: "name", header: "Item", accessor: (r) => r.name ?? "" },
    { key: "kind", header: "Kind", accessor: (r) => r.kind ?? "permanent" },
    { key: "category", header: "Category", accessor: (r) => r.category ?? "" },
    { key: "quantity", header: "Quantity", accessor: (r) => r.quantity ?? 0 },
    { key: "minQuantity", header: "Min. quantity", accessor: (r) => r.min_quantity ?? 0 },
    { key: "lowStock", header: "Low stock", accessor: (r) => isLowStock(r) },
    { key: "location", header: "Location", accessor: (r) => r.venueName ?? "" },
    { key: "condition", header: "Condition", accessor: (r) => r.condition ?? "" },
    { key: "responsible", header: "Responsible", accessor: (r) => r.responsible_name ?? "" },
    { key: "notes", header: "Notes", accessor: (r) => r.notes ?? "" },
  ];
}

export function buildInventoryDataset(
  rows: readonly InventoryExportRow[],
  metadata: ExportMetadata = {},
): ExportDataset {
  return buildDataset(inventoryExportColumns(), rows, {
    title: metadata.title ?? "Inventory",
    ...metadata,
  });
}
